import { PROFILES_FULL } from "../security/security-gql";

export const DATA_PORTALS_LIST = `
  _id
  name
  status
  language
  custom_url
  default_url
  administrators {
  _id
  name
  full_name
  email
  type
  status
  org_status
  organization1
  }
  viewers {
    _id
    name
    full_name
    email
    type
    status
    org_status
    organization1
  }
  ${PROFILES_FULL}
  created
  updated
`;

// Default query for data portal actions
export const DATA_PORTAL_DETAIL = `
  _id
  name
  default_url
  custom_url
  status
  language
  created
  updated
  administrators {
    _id
    name
    full_name
    email
    type
    status
    org_status
    organization1
  }
  viewers {
    _id
    name
    full_name
    email
    type
    status
    org_status
    organization1
  }
  ${PROFILES_FULL}
`;

// Default query for data portal detail page
export const DATA_PORTAL_DETAIL_PAGE = `
  _id
  name
  default_url
  custom_url
  status
  created
  updated
  language
  administrators {
    _id
    name
    full_name
    email
    type
    status
    org_status
    organization1
  }
  viewers {
    _id
    name
    full_name
    email
    type
    status
    org_status
    organization1
  }
`;

// Default query for data portal actions
export const DATA_PORTAL_SELECTOR = `
  _id
  name
  default_url
  custom_url
  status
  language
  created
  administrators {
    _id
    name
    full_name
    email
    type
    status
    org_status
    organization1
  }
  viewers {
    _id
    name
    full_name
    email
    type
    status
    org_status
    organization1
  }
`;



